// src/data/zones.js

export async function getZonesData() {
  const url = process.env.REACT_APP_ZONES_URL;
  if (!url) {
    console.error('No ZONES_URL defined in environment variables.');
    return [];
  }

  try {
    const res = await fetch(url);
    if (!res.ok) {
      throw new Error(`Failed to fetch zones.json (status ${res.status})`);
    }
    const data = await res.json();
    return data; // returns an array of zone objects (at runtime)
  } catch (err) {
    console.error('Error loading zones data:', err);
    return [];
  }
}
